<template>
  <div v-if="is_admin">
    <preloader :is-visible="mainLoader"></preloader>
    <div class="uk-card uk-card-default">
      <!--шапка страницы-->
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <h3 class="uk-card-title uk-margin-remove-top">
              {{ local_page_keys.table_title_users }}
            </h3>
          </div>
          <div class="uk-width-auto">
            <div class="uk-grid uk-grid-small" data-uk-grid>
              <!--search-->
              <div>
                <div class="uk-search uk-search-default" style="width: 300px;">
                  <span data-uk-search-icon class="uk-icon uk-search-icon"></span>
                  <input v-model="searchString" class="uk-search-input" type="search" :placeholder="local_page_keys.search">
                </div>
              </div>
              <!--статус пользователей-->
              <div>
                <select class="uk-select" v-model="modeTable">
                  <option value="active">{{ local_page_keys.active_users }}</option>
                  <option value="deleted">{{local_page_keys.inactive_users}}</option>
                </select>
              </div>
              <!--add btn-->
              <div>
                <button class="uk-button tm-button-success" type="button" @click="openDialogUser('create')">
                  {{ local_page_keys.title_create_user}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--список ползователей-->
      <div class="uk-card-body">
        <!--шапка таблицы-->
        <div class="uk-text-bold" style="background-color: #4caf50; color: #fff;" data-uk-sticky="start: 200; animation: uk-animation-slide-top">
          <div class="uk-grid uk-grid-collapse uk-text-center uk-flex-middle" data-uk-grid>
            <div class="uk-width-auto user_id">
              <div style="width: 87px;" class="uk-padding-small">
                <div class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                  <div>
                    ID
                  </div>
                  <!--Сортировка по ID-->
                  <div>
                    <a href="#" class="uk-display-inline-block uk-link-reset" :data-uk-tooltip='"title: " + local_page_keys.sorted_by_id'>
                      <span class="uk-icon" @click="setSortingData('id','asc')">
                        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon><line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line></svg>
                      </span>
                      <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="setSortingData('id','desc')">
                        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon><line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line></svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-width-expand">
              <div class="uk-grid uk-grid-collapse uk-child-width-1-6 uk-flex-middle" data-uk-grid>
                <!--name-->
                <div>
                  <div class="uk-padding-small">
                    <div class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{getItemName('name')}}
                      </div>
                      <!--Сортировка по имени-->
                      <div>
                        <a href="#" class="uk-display-inline-block uk-link-reset"  :data-uk-tooltip='"title: " + local_page_keys.sorted_by_name'>
                          <span class="uk-icon" @click="setSortingData('name','asc')">
                            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon><line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line></svg>
                          </span>
                          <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="setSortingData('name','desc')">
                            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon><line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line></svg>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <!--email-->
                <div>
                  <div class="uk-padding-small">
                    <div class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{getItemName('email')}}
                      </div>
                      <!--Сортировка по email-->
                      <div>
                        <a href="#" class="uk-display-inline-block uk-link-reset"  :data-uk-tooltip='"title: " + local_page_keys.sorted_by_email'>
                          <span class="uk-icon" @click="setSortingData('email','asc')">
                            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon><line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line></svg>
                          </span>
                          <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="setSortingData('email','desc')">
                            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon><line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line></svg>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <!--login-->
                <div>
                  <div class="uk-padding-small">
                    <div class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{getItemName('login')}}
                      </div>
                      <!--Сортировка по login-->
                      <div>
                        <a href="#" class="uk-display-inline-block uk-link-reset"  :data-uk-tooltip='"title: " + local_page_keys.sorted_by_login'>
                          <span class="uk-icon" @click="setSortingData('login','asc')">
                            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon><line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line></svg>
                          </span>
                          <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="setSortingData('login','desc')">
                            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon><line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line></svg>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <!--telegram_id-->
                <div>
                  <div class="uk-padding-small">
                    <div class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{getItemName('telegram_id')}}
                      </div>
                      <!--Сортировка по Telegram ID-->
                      <div>
                        <a href="#" class="uk-display-inline-block uk-link-reset"  :data-uk-tooltip='"title: " + local_page_keys.sorted_by_telegram_id'>
                          <span class="uk-icon" @click="setSortingData('telegram_id','asc')">
                            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon><line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line></svg>
                          </span>
                          <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="setSortingData('telegram_id','desc')">
                            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon><line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line></svg>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <!--role-->
                <div>
                  <div class="uk-padding-small">
                    <div class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{getItemName('role')}}
                      </div>
                      <!--Сортировка по роли-->
                      <div>
                        <a href="#" class="uk-display-inline-block uk-link-reset" :data-uk-tooltip='"title: " + local_page_keys.sorted_by_role'>
                          <span class="uk-icon" @click="setSortingData('role','asc')">
                            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon><line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line></svg>
                          </span>
                          <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="setSortingData('role','desc')">
                            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon><line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line></svg>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Профиль-->
                <div>
                  <div class="uk-padding-small">
                    Профиль
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-width-auto action_buttons">
              <div style="width: 150px;" class="uk-padding-small"></div>
            </div>
          </div>
        </div>

        <!--таблица пользователей-->
        <div v-for="(user, key) in usersList" :key="key">
          <div class="uk-grid uk-grid-collapse uk-text-center uk-flex-middle tm-grid-bg-hover" data-uk-grid>
            <div class="uk-width-auto user_id">
              <div style="width: 87px;" class="uk-padding-small">
                {{user.id}}
              </div>
            </div>
            <div class="uk-width-expand">
              <div class="uk-grid uk-grid-collapse uk-child-width-1-6 uk-flex-middle" data-uk-grid>
                <div>
                  <div class="uk-padding-small uk-text-truncate">{{user.name}}</div>
                </div>
                <div>
                  <div class="uk-padding-small uk-text-truncate">{{user.profile.user_email}}</div>
                </div>
                <div>
                  <div class="uk-padding-small uk-text-truncate">{{user.email}}</div>
                </div>
                <div>
                  <div class="uk-padding-small">{{user.telegram_id}}</div>
                </div>
                <div>
                  <div class="uk-padding-small">{{user.role}}</div>
                </div>
                <div>
                  <div class="uk-padding-small" v-html="completionProfile(user)"></div>
                </div>
              </div>
            </div>
            <div class="uk-width-auto action_buttons">
              <div v-if="modeTable === 'active'" style="width: 150px;" class="uk-padding-small">
                <button @click="openDialogUser('edit',user)" type="button" class="uk-button uk-button-small uk-button-success" :data-uk-tooltip='"title: " + local_page_keys.table_tooltip_edit_user'>
                  <md-icon>manage_accounts</md-icon>
                </button>
                <button @click="deleteUser(user.id)" type="button" class="uk-button uk-button-small uk-button-danger uk-margin-xsmall-left" :data-uk-tooltip='"title: " + local_page_keys.table_tooltip_delete_user'>
                  <md-icon>delete</md-icon>
                </button>
              </div>
              <div v-else style="width: 150px;" class="uk-padding-small">
                <button @click="restoreUser(user.id)" type="button" class="uk-button uk-button-small uk-button-success" :data-uk-tooltip='"title: " + local_page_keys.table_tooltip_restore_user' >
                  <md-icon>replay</md-icon>
                </button>
              </div>
            </div>
          </div>
          <hr class="uk-margin-remove">
        </div>

        <!--результат поиска-->
        <div v-if="!Object.keys(usersList).length" class="uk-padding-small uk-text-center">
          {{local_page_keys.search_not_results}}
        </div>
      </div>

        <!--модальное окно редактирования юзера-->
        <div v-if="showDialogUser" style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast" @blur="closeModalUser">
          <div class="uk-modal-dialog tm-func-modal" v-click-outside="closeModalUser">
            <div class="uk-modal-header">
              <div class="tm-background-green uk-padding-xsmall uk-position-top-right uk-text-bold tm-light 8"
                   style="cursor: pointer;"
                   @click="closeModalUser">
                <md-icon>close</md-icon>
              </div>
              <div class="uk-modal-title">
                <div class="uk-grid uk-flex-middle uk-grid-small" data-uk-grid>
                  <div>
                    <h4 class="uk-text-bold">
                      {{ titleModal }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-modal-body">
              <div id="new_user" class="uk-grid uk-grid-divider uk-child-width-1-2" data-uk-grid>
                <div>
                  <div class="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid>
                    <div class="role">
                      <div class="uk-margin-small">
                        {{ local_page_keys.label_choose_role }}
                      </div>
                      <select class="uk-select" :class="formErrors.role ? ' uk-form-danger ' : ''"
                              v-model="user.role"
                              name="selectRole">
                        <option value="" disabled selected hidden>--</option>
                        <option v-for="option in users_roles"
                                :key="option[0]"
                                :value="option[1]"
                                v-text="option[1]">
                        </option>
                      </select>
                    </div>
                    <div class="first_name">
                      <div class="uk-margin-small">
                        {{ local_page_keys.label_name }}*
                        <md-icon class="uk-text-success uk-margin-xsmall-left">error_outline</md-icon>
                        <div class="uk-dropdown tm-dropdown tm-dropdown-right-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 100; delay-show: 0; offset: 10">
                          <div v-html="local_page_keys.profile_info_for_name"></div>
                        </div>
                      </div>
                      <input v-model="user.profile.first_name" class="uk-input" :class="{'uk-form-danger': formErrors.first_name}" type="text"/>
                    </div>
                    <template v-if="isExtendedProfile()">
                      <div class="surname">
                        <div class="uk-margin-small">
                          {{local_page_keys.label_last_name}}*
                          <md-icon class="uk-text-success uk-margin-xsmall-left">error_outline</md-icon>
                          <div class="uk-dropdown tm-dropdown tm-dropdown-right-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 100; delay-show: 0; offset: 10">
                            <div v-html="local_page_keys.profile_info_for_last_name"></div>
                          </div>
                        </div>
                        <input v-model="user.profile.last_name" class="uk-input" :class="{'uk-form-danger': formErrors.last_name}" type="text"/>
                      </div>
                      <div class="phone_number">
                        <div class="uk-margin-small">
                          {{local_page_keys.label_phone_number}}*
                          <md-icon class="uk-text-success uk-margin-xsmall-left">error_outline</md-icon>
                          <div class="uk-dropdown tm-dropdown tm-dropdown-right-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 100; delay-show: 0; offset: 10">
                            <div v-html="local_page_keys.profile_info_for_phone"></div>
                          </div>
                        </div>
                        <input v-model="user.profile.phone_number" :class="{'uk-form-danger': formErrors.phone_number}" class="uk-input" type="text"/>
                      </div>
                      <div class="user_email">
                        <div class="uk-margin-small">
                          {{ local_page_keys.label_email }}*
                          <md-icon class="uk-text-success uk-margin-xsmall-left">error_outline</md-icon>
                          <div class="uk-dropdown tm-dropdown tm-dropdown-right-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 100; delay-show: 0; offset: 10">
                            <div v-html="local_page_keys.profile_info_for_email"></div>
                          </div>
                        </div>
                        <input v-model="user.profile.user_email" class="uk-input" :class="{'uk-form-danger': formErrors.user_email}" />
                      </div>
                    </template>
                  </div>
                </div>
                <div>
                  <div class="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid>
                    <div class="email">
                      <div class="uk-margin-small">
                        {{ local_page_keys.label_login }}*
                      </div>
                      <input v-model="user.email" class="uk-input" :class="formErrors.email ? ' uk-form-danger ' : ''"/>
                    </div>
                    <div class="telegramID">
                      <div class="uk-margin-small">
                        {{ local_page_keys.table_label_telegram_id }}
                        <md-icon class="uk-text-success uk-margin-xsmall-left">error_outline</md-icon>
                        <div class="uk-dropdown tm-dropdown tm-dropdown-right-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 100; delay-show: 0; offset: 10">
                          <div v-html="local_page_keys.profile_telegram_id"></div>
                        </div>
                      </div>
                      <input v-model="user.telegram_id" class="uk-input"/>
                    </div>
                    <div class="orderPage" v-if="user.role == 'retoucher' || user.role == 'junior-retoucher'">
                      <div class="uk-margin-small">
                        <!--{{ local_page_keys.label_choose_order_page }}-->
                        Верcия страницы заказа
                      </div>
                      <select class="uk-select"
                              :class="formErrors.orderPage ? ' uk-form-danger ' : ''"
                              v-model="user.order_page"
                              name="selectOrderPage">
                        <option value="" disabled selected hidden>--</option>
                        <option v-for="option in users_orders_pages"
                                :key="option.key"
                                :value="option.key"
                                v-text="option.text">
                        </option>
                      </select>
                    </div>
                    <div class="new_password">
                      <div class="uk-margin-small">
                        {{ local_page_keys.label_password }}*
                      </div>
                      <input v-model="user.password1" class="uk-input" :class="formErrors.password1 ? ' uk-form-danger ' : ''"/>
                    </div>
                    <div class="repeat_password">
                      <div class="uk-margin-small">
                        {{ local_page_keys.label_password_again }}*
                      </div>
                      <input v-model="user.password2" class="uk-input" :class="formErrors.password2 ? ' uk-form-danger ' : ''"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-modal-footer">
              <!--кнопки-->
              <div class="uk-grid uk-flex-right" data-uk-grid>
                <div v-if="modeModal==='create'">
                  <button :disabled="loader" type="button" class="uk-button uk-button-success tm-light" @click="createUser()">
                    {{ local_page_keys.button_save}}
                    <span v-if="loader" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
                  </button>
                </div>
                <div v-else-if="modeModal==='edit'">
                  <button :disabled="loader" type="button" class="uk-button uk-button-success tm-light" @click="updateUser()">
                    {{ local_page_keys.button_save}}
                    <span v-if="loader" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

    </div>
  </div>
  <!--сообщение о праве доступа к странице-->
  <div v-else class="uk-card uk-card-default">
    <div class="uk-padding uk-text-center">
      <h4>{{ local_page_keys.title_page_access }}</h4>
    </div>
  </div>
</template>
<script>
import Preloader from "../Components/Preloader";

export default {
  components: {Preloader},
  data() {
    return {
      users: [],
      usersList: [],
      remoteUsers: [],
      users_roles: [],
      is_admin: false,
      selectRoles: [],
      selectedOrderPage: [],
      local_page_keys: {},
      showDialogUser: false,
      user: {
        'id': '',
        'email': '',
        'role': '',
        'password1': '',
        'password2': '',
        'telegram_id': '',
        'order_page': 1,
        'profile': {
          'first_name': '',
          'last_name': '',
          'user_email': '',
          'phone_number': ''
        }
      },
      users_orders_pages: [
        {key: 1, text: 'standard'}, {key: 2, text: 'func-based'}
      ],
      titleModal: '',
      modeModal: '',
      loader: false,
      searchString: '',
      sort: {
        field: 'id',
        type: 'asc',
      },
      modeTable: 'active',
      mainLoader: true,
      formErrors: {}
    };
  },
  methods: {
    async fetchSalaryData() {
      try {
        await this.$store.dispatch('users/usersList');
        let data = await this.$store.getters['users/usersList'];

        if (data) {
          this.users = data['users'];
          this.remoteUsers = data['remote_users'];
          this.selectRoles = data['roles'];
          this.users_roles = Object.entries(data['roles']);
          this.is_admin = data['isAdmin'];
          this.userID = data['userID'];
        } else {
          this.errors = this.local_page_keys.alert_failed_get_users_list;
        }
      } catch (e) {
        alert(e);
      }
      this.mainLoader = false;
    },
    search() {
      this.usersList = Object.values(this.usersList).filter(item => {
        return (
            item.name.toLowerCase().includes(this.searchString.toLowerCase()) ||
            item.email.toLowerCase().includes(this.searchString.toLowerCase()) ||
            (item.telegram_id && item.telegram_id.includes(this.searchString)) ||
            String(item.id).includes(this.searchString) ||
            item.role.toLowerCase().includes(this.searchString.toLowerCase())
        );
      });
    },
    sorting(field, type) {
      if (type === 'asc') {
        this.usersList = this.usersList.sort((a, b) => (a[field] > b[field]) ? 1 : ((b[field] > a[field]) ? -1 : 0));
      } else {
        this.usersList = this.usersList.sort((a, b) => (b[field] > a[field]) ? 1 : ((a[field] > b[field]) ? -1 : 0));
      }
    },
    setSortingData(field, type) {
      this.sort.type = type === 'asc' ? 'asc' : 'desc';
      this.sort.field = field;
      this.rebuild();
    },
    openDialogUser(mode, item) {
      this.formErrors = {};
      if (mode === 'edit') {
        this.user = {
          'id': item.id,
          'name': item.name,
          'email': item.email,
          'role': item.role,
          'telegram_id': item.telegram_id,
          'profile' : {
            'first_name': item.profile.first_name,
            'last_name': item.profile.last_name,
            'user_email': item.profile.user_email,
            'phone_number':item.profile.phone_number,
          }
        }
        if(this.user.role == 'retoucher' || this.user.role == 'junior-retoucher'){
          this.user['order_page'] = 'order_page' in item && Number(item.order_page) > 0 ?  Number(item.order_page) : 1;
        }
        this.titleModal = this.user.email;
      } else {
        this.titleModal = this.local_page_keys.title_new_user;
      }
      this.showDialogUser = true;
      this.modeModal = mode;
    },
    async deleteUser(item) {
      if (item === this.userID) {
        return alert(this.local_page_keys.alert_you_cannot_delete_your_user);
      }
      let message = this.local_page_keys.alert_you_sure_you_want_to_delete_the_user + ' ID = ' + item + '?';
      if (confirm(message)) {
        let data = {'id': item};
        await this.$store.dispatch('users/delUser', JSON.stringify(data));
        let user = await this.$store.getters['users/delUser'];
        if (user) {
          UIkit.notification({
            message: 'Пользователь успешно удален',
            pos: 'top-center',
            status: 'success',
            timeout: 1500
          })
          this.users = user.updateUser.users;
          this.remoteUsers = user.updateUser.remote_users;
          this.users_roles = Object.entries(user.updateUser.roles);
          this.rebuild();
        }
      }
    },
    async restoreUser(user_id){
      let message = 'Вы точно хотите восстановить пользователя с ID = ' + user_id + '?';
      if (confirm(message)) {
        let data = {'id': user_id};
        await this.$store.dispatch('users/restoreUser', JSON.stringify(data));
        let user = await this.$store.getters['users/restoreUser'];
        if (user) {
          UIkit.notification({
            message: 'Пользователь успешно восстановлен',
            pos: 'top-center',
            status: 'success',
            timeout: 1500
          })
          this.users = user.restoreUser.users;
          this.remoteUsers = user.restoreUser.remote_users;
          this.users_roles = Object.entries(user.restoreUser.roles);
          this.rebuild();
        }
      }
    },
    async createUser() {
      if(!this.validation()) {
        return;
      }
      let message = this.local_page_keys.alert_add_a_new_user;
      if (confirm(message)) {
        this.loader = true;
        try {
          await this.$store.dispatch('users/createUser', JSON.stringify(this.user))
          let response = await this.$store.getters['users/createUser'];
          if (!response.createUser.error) {
            UIkit.notification({
              message: 'Пользователь успешно добавлен',
              pos: 'top-center',
              status: 'success',
              timeout: 1500
            })
            await this.fetchSalaryData();
            this.rebuild();
            this.closeModalUser();
            //location.reload();
          } else if (response.createUser.error) {
            UIkit.notification({
              message: response.createUser.error,
              pos: 'top-center',
              status: 'danger',
              timeout: 1500
            })
          }
        } catch (error) {
          alert('Произошла ошибка: ', error);
        }
        this.loader = false;
      }
    },
    async updateUser() {
      if(!this.validation()) {
        return;
      }
      let message = this.local_page_keys.alert_save_changes_for_the_user + ' ';
      if (confirm(message)) {
        this.loader = true;
        try {
          await this.$store.dispatch('users/updateUser', JSON.stringify(this.user));
          let response = await this.$store.getters['users/updateUser'];

          if (!response.updateUser.error) {
            UIkit.notification({
              message: 'Пользователь успешно обновлен',
              pos: 'top-center',
              status: 'success',
              timeout: 1500
            })
            this.users = response.updateUser.users;
            this.rebuild();
            this.closeModalUser();
          } else if (response.updateUser.error) {
            UIkit.notification({
              message: response.updateUser.error,
              pos: 'top-center',
              status: 'danger',
              timeout: 1500
            })
          }
        } catch (error) {
          alert('Произошла ошибка: ', error);
        }
        this.loader = false;
      }
    },
    validation() {
      let validate = true;
      this.formErrors = {};
      let message = this.local_page_keys.message_required_field;
      let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      let phonePattern = /^\+?[0-9]+$/;

      if (this.user.email) {
        if (!this.user.email.match(mailformat)) {
          this.formErrors.email = true;
          message = this.local_page_keys.alert_incorrect_Email;
        }
      } else {
        this.formErrors.email = true;
      }

      if (this.user.role === 'admin' && !confirm(this.local_page_keys.alert_you_sure_the_user_role_should_be_Admin)) {
        return;
      }

      if (this.user.password1 !== this.user.password2) {
        this.formErrors.password1 = true;
        this.formErrors.password2 = true;
        message = this.local_page_keys.alert_entered_passwords_do_not_match;
      }

      if (!this.user.profile.first_name.trim()) {
        message = 'Имя обязательно к заполнению.';
        this.formErrors.first_name = true;
      }

      if (this.modeModal === 'create') {
        if (this.user.password1 === '' && this.user.password1 === '') {
          this.formErrors.password1 = true;
          this.formErrors.password2 = true;
        }
        if (!this.user.role) {
          this.formErrors.role = true;
        }
      }

      if (this.isExtendedProfile()) {
        if (this.user.profile.phone_number && this.user.profile.phone_number.trim() === '') {
          message = 'Номер телефона обязателен к заполнению.';
          this.formErrors.phone_number = true;
        } else if (!phonePattern.test(this.user.profile.phone_number)) {
          message = 'Номер телефона должен содержать только цифры или знак + в начале.';
          this.formErrors.phone_number = true;
        }

        if (this.user.profile.user_email && this.user.profile.user_email.trim() === '') {
          message = 'Email обязателен к заполнению.';
          this.formErrors.user_email = true;
        } else if (!mailformat.test(this.user.profile.user_email)) {
          message = 'Неверный формат email.';
          this.formErrors.user_email = true;
        }

        if (!this.user.profile.last_name.trim()) {
          message = 'Фамилия обязательна к заполнению.';
          this.formErrors.last_name = true;
        }
      }

      if (Object.keys(this.formErrors).length)
        validate = false;

      if (!validate) {
        UIkit.notification({
          message: message,
          pos: 'top-center',
          status: 'danger',
          timeout: 1500
        })
      }

      return validate;
    },
    getItemName(item) {
      if (item == 'name') {
        return this.local_page_keys.table_label_name;
      } else if (item == 'role') {
        return this.local_page_keys.table_label_role;
      } else if (item == 'new_password') {
        return this.local_page_keys.table_label_new_password;
      } else if (item == 'repeat_password') {
        return this.local_page_keys.table_label_repeat_password;
      } else if (item == 'save') {
        return "";
      } else if (item == 'del') {
        return "";
      } else if (item == 'email') {
        return this.local_page_keys.table_label_email;
      } else if (item == 'login') {
        return this.local_page_keys.table_label_login;
      } else if (item == 'telegram_id') {
        return this.local_page_keys.table_label_telegram_id;
      }
      else {
        return item;
      }
    },
    closeModalUser() {
      this.showDialogUser = false;
      //очищаем форму
      for (var key in this.user) {
        if (key !== 'profile' && this.user.hasOwnProperty(key)) {
          this.user[key] = '';
        }
      }
      for (var key in this.user.profile) {
        if (this.user.profile.hasOwnProperty(key)) {
          this.user.profile[key] = '';
        }
      }
    },
    async rebuild() {
      this.usersList =  ( this.modeTable === 'active') ? this.users : this.remoteUsers;
      await this.search();
      await this.sorting(this.sort.field, this.sort.type);
    },
    isExtendedProfile(){
      return ['retoucher', 'pro-retoucher'].indexOf(this.user.role) !== -1;
    },
    completionProfile(user) {
      if (['retoucher', 'pro-retoucher'].indexOf(user.role) === -1)
        return;

      let filledCount = 0;
      const requiredFields = ['last_name', 'first_name', 'phone_number', 'user_email', 'avatar'];

      for (let field of requiredFields) {
        if (user.profile[field] || user[field]) {
          filledCount++;
        }
      }
      return filledCount === requiredFields.length ?
          '<span data-uk-tooltip="Профайл заполнен"><i class="md-icon md-icon-font tm-color-green md-theme-default">check_circle</i></span>' :
          '<span data-uk-tooltip="Профайл не заполнен полностью"><i class="md-icon md-icon-font tm-color-red md-theme-default">error_outline</i></span>';
    }
  },
  watch: {
    searchString: function (newVal, oldVal) {
      this.rebuild();
    },
    modeTable: function (newVal, oldVal) {
      this.rebuild();
    },
  },

  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPages(['users-page','user-edit-profile','user-change-password']);
    await this.fetchSalaryData();
    this.rebuild();
  }
}
</script>
<style>
  /*Elements*/
  /*@import '../../../assets/css/uikit/table.css';*/
  @import '../../../assets/css/uikit/icon.css';
  /*@import '../../../assets/css/uikit/form.css';*/
  /*Layout*/
  /*@import '../../../assets/css/uikit/grid.css';*/
  /*@import '../../../assets/css/uikit/section.css';*/
  /*@import '../../../assets/css/uikit/container.css';*/
  /*Utilities*/
  /*@import '../../../assets/css/uikit/width.css';*/
  /*@import '../../../assets/css/uikit/button.css';*/
  /*@import '../../../assets/css/custom.css';*/
</style>